export const GET_PROFILE_METRICS_ATTEMPT = 'GET_PROFILE_METRICS_ATTEMPT';
export type GET_PROFILE_METRICS_ATTEMPT = typeof GET_PROFILE_METRICS_ATTEMPT;

export const GET_PROFILE_METRICS_SUCCESS = 'GET_PROFILE_METRICS_SUCCESS';
export type GET_PROFILE_METRICS_SUCCESS = typeof GET_PROFILE_METRICS_SUCCESS;

export const GET_PROFILE_METRICS_FAILURE = 'GET_PROFILE_METRICS_FAILURE';
export type GET_PROFILE_METRICS_FAILURE = typeof GET_PROFILE_METRICS_FAILURE;


// WEBPACK FOOTER //
// ./src/actions/profile-metrics/get/Types.tsx